<template>
  <div class="my-user-info">
    <img class="my-user-bg" src="../../../../picture/my/header-bg.png" />
    <div class="my-user-content">
      <div class="my-user-info-content">
        <div class="my-user-icon-box">
          <img
            class="my-head-image"
            v-if="userInfo.headImgUrl"
            :src="userInfo.headImgUrl | getFilePath"
            alt=""
          />
          <img
            class="my-head-image"
            v-else
            src="../../../../picture/img/my-def.png"
            alt=""
          />
        </div>
        <div class="my-user-box">
          <div class="my-user-name">{{ userInfo.userName }}</div>
          <div class="my-user-phone">{{ userInfo.phoneNo || "--" }}</div>
          <div class="user-type">
            <pi-user-tag
              :userType="userType"
              :vipType="accountObj.vipLevel || 0"
            ></pi-user-tag>
          </div>
        </div>
        <div class="my-user-right" v-if="configData.openPoint">
          <div class="register-btn" @click="registerClick">签到</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import userTag from "@/components/pi-user-tag/pi-user-tag";
export default {
  name: "pi-my-user-info",
  components: {
    [userTag.name]: userTag,
  },
  data() {
    return {};
  },
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
    userInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    accountObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    configData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    userType: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    async registerClick() {
      this.$router.push("/my-register");
    },
  },
};
</script>
<style lang="less" scoped>
.my-user-info {
  position: relative;
  height: 2rem;
}
.my-user-bg {
  width: 100%;
  height: 100%;
}
.my-user-content {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}
.my-user-info-content {
  display: flex;
  padding: 0.3rem 0.2rem 0.15rem 0.3rem;
}

.my-user-content .my-user-icon-box .my-head-image {
  width: 1rem;
  height: 1rem;
  vertical-align: top;
  border-radius: 50%;
}
.my-user-content .my-user-box {
  flex: 1;
  padding-left: 0.2rem;
}
.my-user-content .my-user-box .my-user-name {
  padding-top: 0.05rem;
  font-size: 0.32rem;
  line-height: 0.45rem;
  color: #000;
}
.my-user-content .my-user-box .my-user-phone {
  margin-top: 0.1rem;
  font-size: 0.28rem;
  line-height: 0.4rem;
  color: #999;
}
.my-user-content .my-user-box .user-type {
  margin-top: 0.1rem;
}
.my-user-right {
  padding-top: 0.22rem;
}
.my-user-right .register-btn {
  width: 1.15rem;
  height: 0.56rem;
  line-height: 0.56rem;
  background: linear-gradient(90deg, #ffffff 0%, #efeff4 100%);
  box-shadow: 0px 0px 0.1rem 0px #f5f5f5;
  border-radius: 0.28rem;
  font-size: 0.28rem;
  text-align: center;
}
</style>
